import { useState } from "react";

export default function BuildingStatus({isSmall, defaultValue, errors }) {
  const [selected, setSelected] = useState([]);

 const handleClick = (value) => {
   if (selected.includes(value)) {
     setSelected(selected.filter((v) => v !== value)); // снимаем выбор при повторном клике
   } else {
     setSelected([...selected, value]); // выбираем новое значение
   }
  };
  const [isSmall1] = useState(window.innerWidth <= 900);
  const options = [
    { id: "ss1", label: isSmall1 ? "ՎԵՐ.": "ՎԵՐԱՆՈՐՈԳՎԱԾ" , value: "Renovated" },
    { id: "ss2", label: isSmall1 ? "ԼԱՎ": "ԼԱՎ" , value: "Good-Condition" },
    { id: "ss3", label: isSmall1 ? "ԶՐՈ.": "ԶՐՈՅԱԿԱՆ" , value: "Zero-Condition" },
  ];

  return (
    <div
      className="buildingStatus"
      style={{
        border: errors?.building_status ? "2px solid red" : "none",
        borderRadius: "10px",
        padding: "5px",
      }}
    >
        <h5>
          {" "}
          {isSmall1 ? "Կ-ՎԻՃ." : isSmall ? "ՇԻՆ. ՎԻՃԱԿ" : "ՇԻՆՈՒԹՅԱՆ ՎԻՃԱԿ"}
        </h5>
      
      <div className="with ">
          {options.map((option) => (
            <div key={option.id}>
              <input
                type="checkbox"
                name="building_status"
                id={option.id}
                value={option.value}
                checked={
                  selected.includes(option.value) ||
                  (!selected.length && option.value === defaultValue)
                }
                onChange={() => handleClick(option.value)}
              />
              <label htmlFor={option.id}>{option.label}</label>
            </div>
          ))}
        </div>
    </div>
  );
}
